/**

Project: BKN_FRONT
Copyright (c) 2023 Nttdata

*/
export const AUTH_TOKEN = "BKINT_JWT";
export const BACKEND_ERROR_MSG = "BKINT_ERROR_MSG";
export const STORAGE_USUARI = "usuari";

export const CONTENT_TYPE_JSON = "Content-Type': 'application/json";
export const GRIS_FOSC = "#3E3E3E";
export const GRIS_FONS = "#fafafa";
export const GRIS = "#5D5760";
export const BLANC = "#FFFFFF";
export const VERMELL = "#900000";
export const FONT_RUTA = "/fonts/open-sans-v34-latin-regular.woff2";
export const TARONJA = "#cc6600";
export const VERD = "#007567";
export const VERD_CLAR = "#00b347";
export const GROC = "#ccac00";
export const VERMELL_CHIP = "#BF360C";
